<template>
    <AppLayout>

        <template #subheader>
            <div class="d-flex align-items-center justify-content-between w-100">

                <!-- LEWA STRONA -->
                <div class="d-flex align-items-center gap-3 flex-wrap">

                    <!-- Projekt -->
                    <div class="d-flex align-items-center gap-2">
                        <label for="project-select" class="mb-0">Projekt:</label>
                        <select id="project-select"
                            class="form-select form-select-sm"
                            @change="updateSelectedProject"
                            v-model="selectedProjectId"
                            style="min-width: 240px;max-width: 1000px;">
                            <option value="0">Wszystkie projekty</option>
                            <option v-for="project in projects"
                                :key="project.id"
                                :value="project.id">
                                {{ project.label }}
                            </option>
                        </select>
                    </div>

                    <!-- Zespół -->
                    <div class="d-flex align-items-center gap-2 me-5">
                        <label for="team-select" class="mb-0">Zespół:</label>
                        <select id="team-select"
                            class="form-select form-select-sm"
                            @change="updateSelectedTeam"
                            v-model="selectedTeamName"
                            :disabled="!selectedProjectId || (teams && teams.length === 0)"
                            style="min-width: 180px;">
                            <option value="">Wszystkie zespoły</option>
                            <option v-for="team in teams"
                                :key="team.name"
                                :value="team.name">
                                {{ team.name }}
                            </option>
                        </select>
                    </div>

                </div>

                <!-- PRAWA STRONA -->
                <div class="d-flex align-items-center gap-3">
                </div>

            </div>
        </template>


        <!-- Spinner ładowania -->
        <div v-if="isLoading" class="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style="z-index:1050; background:rgba(255,255,255,0.7);">
            <div class="spinner-border text-primary" role="status" style="width:4rem;height:4rem;">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div class="container mt-4">
            <div class="container-fluid mb-4">

                <!-- Nagłówek sekcji -->
                <div class="mb-3 border-bottom pb-2 d-flex flex-wrap align-items-center justify-content-between">
                    <div class="d-flex align-items-center flex-wrap gap-3">
                        <h4 class="my-0"><strong>Import z pliku XLSX (Inventor)</strong></h4>
                        <h5 class="my-0 text-primary"><strong>{{ productionout_name }}</strong></h5>
                    </div>

                    <div class="d-flex align-items-center flex-wrap gap-3">
                        <button
                            v-if="selectedErpArticles.length > 0"
                            class="btn btn-primary btn-sm"
                            @click="openRequiredProjectItemsModal">
                            Utwórz zapotrzebowanie projektowe ({{ selectedErpArticles.length }})
                        </button>

                        <Link :href="route('inventor.parser.index')" class="btn btn-outline-primary btn-sm">
                        <i class="bi bi-list"></i>&nbsp;Powrót do listy
                        </Link>
                        <button v-if="entries.length > 0" class="btn btn-success btn-sm" @click="exportToExcel">
                            <i class="bi bi-file-earmark-excel"></i>&nbsp;Eksportuj do Excel
                        </button>
                        <div class="position-relative">
                            <input type="text" class="form-control form-control-sm pe-5" placeholder="Szukaj..." v-model="searchTermRaw">
                            <button class="btn position-absolute end-0 top-0 bottom-0 d-flex align-items-center px-2" @click="searchTermRaw = ''" style="border: none; background: transparent;"><i class="bi bi-x-lg"></i></button>
                        </div>


                    </div>
                </div>

                <div v-if="entries.length > 0" class="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
                    <form @submit.prevent="submitArchived" class="d-flex align-items-center gap-2">
                        <div class="form-check m-0">
                            <input id="productionoutarchived" type="checkbox" class="form-check-input"
                                :checked="archived" @change="changeProductionOutArchived" />
                            <label for="productionoutarchived" class="form-check-label h6 mb-0">Archiwizuj</label>
                        </div>
                        <button v-if="archivedHasChanged" type="submit" class="btn btn-primary btn-sm">
                            Zapisz
                        </button>
                    </form>

                    <button @click="wyczysc" class="btn btn-outline-danger btn-sm">
                        <i class="bi bi-trash"></i>&nbsp;Wyczyść tabelę
                    </button>
                </div>

                <!-- Sekcja: Wybór pliku -->
                <div v-if="entries.length == 0" class="mt-3">
                    <label for="xlsxFile" class="form-label fw-semibold">Wybierz plik XLSX:</label>
                    <input
                        id="xlsxFile"
                        type="file"
                        @change="onFileSelected"
                        accept=".xlsx"
                        class="form-control form-control-sm"
                        ref="xlsxFileInput"
                        style="max-width: 400px" />
                </div>

            </div>


            <!-- Tabela z wynikami -->
            <div v-if="entries.length > 0" class="table-responsive mt-4">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th style="width:40px;">Do zapotrzebowania</th>
                            <th style="position:sticky;top:0;left:0;background:white;z-index:20;min-width:100px;">Miniatura</th>
                            <th @click="sortBy('item_start')" style="cursor:pointer;">Item start</th>
                            <th @click="sortBy('item')" style="cursor:pointer;">Item</th>
                            <th @click="sortBy('part_number')" style="cursor:pointer;">Numer części</th>
                            <th @click="sortBy('erp_article_id')" style="cursor:pointer;">ID artykułu</th>
                            <th @click="sortBy('qty')" style="cursor:pointer;">Ilość</th>
                            <th @click="sortBy('description')" style="cursor:pointer;">Materiał</th>
                            <th @click="sortBy('material')" style="cursor:pointer;">Opis</th>
                            <th @click="sortBy('bom_structure')" style="cursor:pointer;">BOM Structure</th>
							<th @click="sortBy('rev')" style="cursor:pointer;">REV</th>
                            <th @click="sortBy('status')" style="cursor:pointer;">Utworzone zapotrebowanie</th>
							</tr>
                    </thead>
                    <tbody>
                       <tr v-for="(entry, index) in sortedEntries" :key="entry.id || index" :class="{ 'row-added': entry.status == 1 }">
                            <td>{{ index + 1 }}</td>
                            <td>
								<div v-if="entry.erp_article_id && entry.status === 0">
									<center>
										<input
											type="checkbox"
											class="erp-checkbox"
											v-model="selectedErpArticles"
											:value="{
												article_id: entry.erp_article_id,
												quantity_required: entry.qty
											}"
										/>
									</center>
								</div>

								<div v-else class="text-center">
									<span class="text-success fw-bold" style="font-size: 24px;" title="Dodano do zapotrzebowania">
										✓
									</span>
								</div>
							</td>
                            <td style="position:sticky;left:0;background:white;z-index:10;">
                                <img v-if="entry.thumbnail" :src="entry.thumbnail" alt="thumbnail" style="max-width:80px;max-height:80px;">
                            </td>
                            <td>{{ entry.item_start }}</td>
                            <td>{{ entry.item }}</td>
                            <td>{{ entry.part_number }}</td>
                            <td v-if="entry.erp_article_id">{{ entry.erp_article_id }}<br><button class="btn btn-info btn-xs" @click="openModal(entry)">Zmień ID</button></td>
                            <td v-else><button class="btn btn-primary btn-xs" @click="openModal(entry)">Dodaj ID</button></td>
                            <td>{{ entry.qty }}</td>
                            <td>{{ entry.material }}</td>
                            <td>{{ entry.description }}</td>
                            <td>{{ entry.bom_structure }}</td>
							<td>{{ entry.rev }}</td>
							<td>{{ entry.status == 1 ? 'TAK' : 'NIE' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-show="isModalOpen" class="modal fade show" tabindex="-1" :style="{ display: isModalOpen ? 'block' : 'none' }">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Artykuły</h5>
                            <button type="button" class="btn-close" @click="closeModal"></button>
                        </div>
                        <div class="modal-body">
                            <p><strong>Numer części:</strong> {{ selectedPartNumber }}</p>

                            <div class="d-flex gap-2 mb-3">
                                <input type="text" class="form-control" placeholder="Wyszukaj artykuł..." v-model="articleSearchQuery" @keyup.enter="searchArticles" />
                                <button class="btn btn-primary btn-sm" @click="searchArticles"><i class="bi bi-search me-2"></i> Szukaj</button>
                            </div>

                            <div v-if="isSearching" class="text-center py-3">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Szukam...</span>
                                </div>
                            </div>

                            <div v-if="searchResults.length > 0" class="table-responsive" style="max-height: 400px;">
                                <table class="table table-sm table-hover">
                                    <thead class="table-light">
                                        <tr>
                                            <th>ID</th>
                                            <th>Catalog number</th>
                                            <th>Model</th>
                                            <th>Opis</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="article in searchResults" :key="article.id">
                                            <td>{{ article.id }}</td>
                                            <td>{{ article.catalog_number }}</td>
                                            <td>{{ article.model }}</td>
                                            <td>{{ article.description }}</td>
                                            <td><button class="btn btn-success btn-sm" @click="selectArticle(article)">Wybierz</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-else-if="!isSearching && articleSearchPerformed" class="alert alert-warning">
                                Brak wyników dla podanego zapytania.
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-success btn-sm" @click="openArticleModalFromEntry">
                                + Nowy artykuł
                            </button>
                            <button type="button" class="btn btn-danger btn-sm" @click="closeModal">Anuluj</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <AddArticleModal ref="addArticleModalRef" @save-article="createArticleFromModal" @added-success="successMsg"
            @added-error="errorMsg" :units="units" :categories="categories" :producers="copyproducers"
            :suppliers="suppliers" :currencys="currencys" />



<AddRequiredProjectItemsModal
    :project="selectedProjectId"
    :team="selectedTeamName"
    :liczba_maszyn="liczba_maszyn"
    :articlesToClone="articlesToClone"
    ref="addRequiredProjectItemsModalRef"
    :suppliers="suppliers"
    :producers="producers"
    :units="units"
    :categories="categories"
    @added-success="successMsg"
    @added-error="errorMsg"
	@clear-selection="clearSelection"
/>


    </AppLayout>
</template>

<script>
    import AppLayout from "@/Layouts/App.vue";
    import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
    import {
        useForm,
        router
    } from "@inertiajs/vue3";
    import AddArticleModal from '@/Pages/Warehouses/Articles/AddArticleModal.vue';
    import AddRequiredProjectItemsModal from "@/Pages/RequiredProjectItems/AddRequiredProjectItemsModal.vue";

    export default {
        components: {
            AppLayout,
            AddArticleModal,
            AddRequiredProjectItemsModal
        },
        props: {
            prid: {
                type: String,
                required: true
            },
            productionout_name: {
                type: String,
                required: true
            },
            archived: {
                type: Boolean,
                required: true
            },
            productionout_data: {
                type: Array,
                default: () => []
            },
            units: Object,
            categories: Object,
            producers: Object,
            suppliers: Object,
            projects: Object,
        },
        data() {
            return {
                selectedProjectId: 0,
                selectedTeamName: '',
                liczba_maszyn: 1,
                articlesToClone: [],

                teams: [],

                selectedErpArticles: [],
                articleSearchQuery: '',
                assignedArticles: {},
                selectedEntry: null,
                isAddingNew: false,
                producer_name: '',
                searchResults: [],
                isSearching: false,
                articleSearchPerformed: false,
                selectedArticleId: null,
                searchTermRaw: '',
                searchTerm: '',
                isModalOpen: false,
                selectedPartNumber: null,
                debounceTimer: null,
                isLoading: false,
                selectedFile: null,
                sortColumn: '',
                sortDirection: 'asc',
                archiveOnListForm: useForm({
                    archived: this.archived
                }),
                archivedHasChanged: false,
                entries: this.productionout_data || [],
            };
        },

        beforeMount() {
            const storedProjectId = sessionStorage.getItem('selectedProjectId');
            const storedTeam = sessionStorage.getItem('selectedTeam');
            if (storedProjectId) {
                this.selectedProjectId = (storedProjectId === 'null' || storedProjectId === null) ? 0 : storedProjectId;
                this.updateTeams();
            }
            this.selectedTeamName = storedTeam;
            this.getQutoeRequestsForProject();
        },

        watch: {

            searchTermRaw(newVal) {
                clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(() => {
                    this.searchTerm = newVal;
                }, 200);
            },
            isModalOpen(val) {
                if (val) {
                    this.searchResults = [];
                    this.articleSearchQuery = '';
                    this.articleSearchPerformed = false;
                    this.isSearching = false;
                }
            }
        },
        computed: {
            filteredEntries() {
                const term = this.searchTerm?.trim().toLowerCase();
                if (!term) return this.entries;
                const searchFields = ['item', 'part_number', 'erp_article_id', 'description', 'material', 'bom_structure', 'rev', 'qty'];
                return this.entries.filter(entry => {
                    const matchesField = searchFields.some(key => {
                        const value = entry[key];
                        if (value === undefined || value === null) return false;
                        return value.toString().toLowerCase().includes(term);
                    });

                    return matchesField;
                });
            },

            sortedEntries() {
                const sorted = [...this.filteredEntries].sort((a, b) => {
                    const key = this.sortColumn;
                    if (!key) return 0;
                    const aVal = (a[key] !== undefined && a[key] !== null ? a[key].toString().toLowerCase() : '');
                    const bVal = (b[key] !== undefined && b[key] !== null ? b[key].toString().toLowerCase() : '');
                    if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
                    if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
                    return 0;
                });
                return sorted;
            }
        },
        mounted() {
            this.loadData();
            window.addEventListener('toast', (e) => {
                alert(`${e.detail.type}: ${e.detail.message}`);
            });
        },
        methods: {
		
async clearSelection() {
    try {
        const inventorIds = this.selectedErpArticles
            .map(selected => {
                const entry = this.entries.find(
                    e => String(e.erp_article_id) === String(selected.article_id)
                );
                return entry?.id;
            })
            .filter(id => id !== undefined && id !== null);
        if (!inventorIds.length) {
            this.selectedErpArticles = [];
            return;
        }

        const response = await axios.post(
            route('inventor.parser.mark-as-added-to-requirement'),
            {
                ids: inventorIds
            }
        );
        this.selectedErpArticles = [];
    } catch (error) {
        console.error('BŁĄD:', error.response?.data || error);
        this.errorMsg(
            'Nie udało się oznaczyć artykułów jako dodanych do zapotrzebowania.'
        );
    }
},

            async getArticlesForRequiredModal() {
                const selected = this.selectedErpArticles;

                if (!selected.length) {
                    return [];
                }

                const ids = selected.map(item => item.article_id);

                const response = await axios.post(
                    route('inventor.parser.articlesByIds'), {
                        ids: ids
                    }
                );

                const articles = response.data || [];

                return selected.map(selectedArticle => {
                    const article = articles.find(
                        a => String(a.id) === String(selectedArticle.article_id)
                    );

                    if (!article) {
                        console.warn(
                            'Nie znaleziono artykułu ERP:',
                            selectedArticle.article_id
                        );
                        return null;
                    }

                    return {
                        article: article,
                        quantity_required: selectedArticle.quantity_required
                    };
                }).filter(Boolean);
            },

            sendToRequiredModal(ids) {
                if (!ids.length) return;

                const articles = this.entries
                    .filter(e => ids.includes(e.erp_article_id))
                    .filter(e => !this.selectedArticles.some(a => a.id === e.erp_article_id))
                    .map(e => ({
                        id: e.erp_article_id
                    }));

            },

            updateSelectedProject(event) {
                this.selectedProjectId = Number(event.target.value);
                this.teams = null;
                this.selectedTeamName = null;
                if (this.selectedProjectId) {
                    this.updateTeams()
                }

                this.getQutoeRequestsForProject();
            },

            updateTeams() {
                if (this.selectedProjectId) {
                    const project = this.projects.find(
                        project => project.id === Number(this.selectedProjectId)
                    );

                    if (project) {
                        this.teams = project.teams;
                        this.selectedTeamName = null;
                    }
                }
            },

            updateSelectedTeam(event) {
                this.selectedTeamName = event.target.value;
                this.getQutoeRequestsForProject();
            },

            getQutoeRequestsForProject() {
                sessionStorage.setItem('selectedProjectId', this.selectedProjectId);
                sessionStorage.setItem('selectedTeam', this.selectedTeamName);
            },

            openArticleModalFromEntry() {
                const modal = this.$refs.addArticleModalRef;

                const entry = this.selectedEntry;

                modal.resetForm();

                modal.setDataFromClone({
                    catalog_number: entry.part_number,
                    description: entry.description,
                    details: entry.material,
                    model: entry.part_number,
                });

                modal.show();
            },

            setDataFromClone(article) {
                if (!article) return;

                this.catalog_number = article.catalog_number ?? '';
                this.model = article.model ?? '';
                this.description = article.description ?? '';
                this.details = article.details ?? '';
                this.link = article.link ?? '';
                this.location = article.location ?? '';

                this.article_unit_id = article.unit_id ?? null;
                this.producer_id = article.producer_id ?? null;
                this.category_id = article.category_id ?? null;

                this.producerSearch = article.producer_name ?? '';
            },

            createNewFromSearch(article) {
                const clone = {
                    catalog_number: article.catalog_number || this.selectedPartNumber,
                    model: article.model || '',
                    description: article.description || '',
                    unit_id: null,
                    producer_id: null,
                    category_id: null,
                };

                const modal = this.$refs.addArticleModalRef;

                modal.resetForm();
                modal.setDataFromClone(clone);
                modal.show();
            },

            successMsg(resp) {
                Toast.fire({
                    position: 'top-end',
                    toast: true,
                    icon: 'success',
                    title: 'Sukces!',
                    html: resp,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    timer: 2500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    showCloseButton: true
                });
            },

            errorMsg(resp) {
                Toast.fire({
                    position: 'top-end',
                    toast: true,
                    icon: 'warning',
                    title: 'Błąd!',
                    html: resp,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    timer: 2500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    showCloseButton: true
                });
            },

            cloneToModal(sourceRow) {
                const clone = JSON.parse(JSON.stringify(sourceRow));
                clone.id = null;
                this.$nextTick(() => {
                    const modal = this.$refs.addArticleModalRef;
                    modal.resetForm();
                    modal.setDataFromClone(clone);
                    modal.show();
                });
            },

            async createArticleFromModal(payload) {
                console.log('payload', payload);
                const existing = await this.checkCatalogNumber(payload.catalog_number);
                if (existing.length > 0) {
                    await this.articleAlreadyExist(existing);
                }
                this.$inertia.post(route('articles.saveChanges'), {
                    added: [payload],
                }, {
                    only: ['errors', 'flash', 'newRecords', 'articles', 'producers'],
                    preserveState: true,

                    onSuccess: (page) => {
                        const flashError = page.props.flash?.error;
                        if (flashError) {
                            Toast.fire({
                                position: 'top-end',
                                toast: false,
                                icon: 'warning',
                                title: 'Błąd zapisu',
                                html: flashError,
                                showConfirmButton: true
                            });

                            this.isAddingNew = false;
                            return;
                        }
                        this.copyproducers = page.props.producers;
                        this.$refs.articlesGrid.ej2Instances.refresh();

                        this.successMsg('Dane zostały zapisane!');
                        this.$makeClean();
                        this.$refs.addArticleModalRef.hide();
                        this.$refs.addArticleModalRef.resetForm();
                    },

                    onError: (errors) => {
                        console.error('Błąd podczas zapisywania danych:', errors);
                        this.errorMsg('Błąd podczas zapisywania danych.');
                        this.isAddingNew = false;
                    }
                });
            },

            async checkCatalogNumber(catalogNumber) {
                if (catalogNumber) {
                    try {
                        const response = await axios.post(route('article.check-catalog-number-if-exists'), {
                            catalog_number: catalogNumber
                        });
                        return response.data;
                    } catch (error) {
                        console.error('Błąd podczas sprawdzania numeru katalogowego:', error);
                        return [];
                    }
                }
                return [];
            },

            async articleAlreadyExist(theSameArticles) {
                let html = '<table class="table table-bordered"><thead><tr><th>Nr Kat.</th><th>Model</th><th>Opis</th></tr></thead><tbody>';
                theSameArticles.forEach(article => {
                    html += '<tr>';
                    html += `<td>${article.catalog_number}`;
                    html += `<td>${article.model || ''}</td>`;
                    html += `<td>${article.description || ''}</td>`;
                    html += '</tr>';
                });

                html += '</tbody></table>';

                const {
                    value: selectedOption
                } = await Toast.fire({
                    position: 'center',
                    toast: false,
                    icon: 'warning',
                    title: 'Istnieje już taki nr katalogowy',
                    html: html,
                    timer: false,
                    showCancelButton: false,
                    showCloseButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Ok',
                });
            },

            openModal(entry) {
                this.selectedEntry = entry;
                this.selectedPartNumber = entry.part_number;
                this.isModalOpen = true;
            },

            closeModal() {
                this.searchResults = [];
                this.articleSearchQuery = '';
                this.articleSearchPerformed = false;
                this.isModalOpen = false;
            },
            async searchArticles() {
                if (!this.articleSearchQuery.trim()) {
                    this.showToast('info', 'Brak danych', 'Wpisz frazę do wyszukania');
                    return;
                }

                this.isSearching = true;
                this.searchResults = [];

                try {
                    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

                    const response = await fetch('/inventor/article/search', {
                        method: 'POST',
                        headers: {
                            'X-CSRF-TOKEN': csrfToken,
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            query: this.articleSearchQuery
                        })
                    });

                    if (!response.ok) throw new Error('Błąd wyszukiwania');
                    const data = await response.json();
                    this.searchResults = data;
                    this.articleSearchPerformed = true;
                } catch (err) {
                    console.error(err);
                    this.showToast('error', 'Uwaga', 'Błąd wyszukiwania artykułów!');
                } finally {
                    this.isSearching = false;
                }
            },

            selectArticle(article) {
                this.selectedArticleId = article.id;
                const partNumber = this.selectedPartNumber;
                console.log("Wybrano artykuł:", {
                    partNumber,
                    articleId: article.id
                });

                const payload = {
                    partNumber: this.selectedPartNumber,
                    id: article.id
                };

                this.$inertia.post(route('inventor.parser.article.add'), payload, {
                    preserveScroll: true,
                    onSuccess: () => {
                        const entry = this.entries.find(e => e.part_number === this.selectedPartNumber);

                        if (entry) {
                            entry.erp_article_id = this.selectedArticleId;
                            this.assignedArticles[entry.part_number] = this.selectedArticleId;
                        }

                        this.closeModal();
                    },
                    onError: () => {
                        this.showToast('error', 'Błąd', 'Nie udało się zapisać id artykułu!');
                    }
                });
            },

            async loadData() {
                this.isLoading = true;

                try {
                    const res = await fetch(route('inventor.parser.data', {
                        prid: this.prid
                    }));
                    if (!res.ok) throw new Error('Błąd pobierania danych');

                    const data = await res.json();

                    this.entries = data;
                    this.assignedArticles = {};

                    this.entries.forEach(e => {
                        if (e.part_number && e.erp_article_id) {
                            this.assignedArticles[e.part_number] = e.erp_article_id;
                        }
                    });

                    this.entries.forEach(entry => {
                        const entryId = entry.item_id || entry.id || entry.item;
                    });

                } catch (err) {
                    console.error(err);
                    this.entries = [];
                } finally {
                    this.isLoading = false;
                }
            },

            onFileSelected(event) {
                const file = event.target.files[0];
                if (!file) return;
                this.selectedFile = file;
                this.uploadFile();
            },

            async uploadFile() {
                if (!this.selectedFile) return;
                this.isLoading = true;

                try {
                    const formData = new FormData();
                    formData.append("file", this.selectedFile);
                    formData.append("prid", this.prid);

                    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

                    const response = await fetch(route('inventor.xlsx.upload'), { 
                        method: "POST",
                        headers: {
                            "X-CSRF-TOKEN": csrfToken,
                            Accept: "application/json",
                        },
                        body: formData,
                    });

                    if (!response.ok) throw new Error("Błąd podczas przesyłania pliku");

                    const data = await response.json();
                    this.entries = data;
                    this.$nextTick(() => {
                        this.showToast(
                            'success',
                            'Plik odczytany',
                            `Wczytano ${data.length} rekordów`
                        );
                    });

                } catch (error) {
                    console.error(error);
                    this.showToast('error', 'Błąd', 'Nie udało się przetworzyć pliku!');
                } finally {
                    this.isLoading = false;
                    this.selectedFile = null;
                    if (this.$refs.xlsxFileInput) this.$refs.xlsxFileInput.value = null;
                }
            },

            sortBy(column) {
                if (this.sortColumn === column) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                } else {
                    this.sortColumn = column;
                    this.sortDirection = 'asc';
                }
            },

            wyczysc() {
                Toast.fire({
                    toast: false,
                    icon: 'warning',
                    title: 'Czyszczenie tabeli',
                    html: 'Czy na pewno chcesz usunąć wszystkie wpisy z bazy?',
                    showDenyButton: true,
                    showConfirmButton: true,
                    confirmButtonText: 'Tak',
                    denyButtonText: 'Nie',
                    timer: false,
                    position: 'center',
                }).then((result) => {
                    if (result.isConfirmed) {
                        const csrfToken = document
                            .querySelector('meta[name="csrf-token"]')
                            .getAttribute('content');

                        fetch(route('inventor.parser.data.delete', {
                                prid: this.prid
                            }), {
                                method: 'DELETE',
                                headers: {
                                    'X-CSRF-TOKEN': csrfToken,
                                    Accept: 'application/json',
                                },
                            })
                            .then((res) => {
                                if (!res.ok) throw new Error();

                                this.entries = [];

                                this.showToast(
                                    'success',
                                    'Gotowe',
                                    'Tabela została wyczyszczona'
                                );
                            })
                            .catch(() => {
                                this.showToast(
                                    'error',
                                    'Błąd',
                                    'Nie udało się usunąć danych'
                                );
                            });
                    }
                });
            },
            submitArchived() {
                this.$inertia.post(
                    route('inventor.parser.updateArchived', {
                        id: this.prid
                    }), {
                        archived: this.archiveOnListForm.archived
                    }, {
                        preserveScroll: true,
                        onSuccess: () => {
                            this.archivedHasChanged = false;
                            this.showToast('success', 'Sukces', 'Status archiwizacji został zaktualizowany.');
                        },
                        onError: () => {
                            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
                        }
                    }
                );
            },
            changeProductionOutArchived() {
                this.archiveOnListForm.archived = event.target.checked;
                this.archivedHasChanged = true;
            },
async openRequiredProjectItemsModal() {

    if (!this.selectedErpArticles.length) {
        this.errorMsg('Nie zaznaczono żadnych artykułów.');
        return;
    }

    if (
        !this.selectedProjectId ||
        this.selectedProjectId === '0' ||
        !this.selectedTeamName ||
        this.selectedTeamName === 'null'
    ) {
        this.errorMsg('Najpierw wybierz projekt i zespół.');
        return;
    }

    const project = this.projects.find(
        p => p.id === Number(this.selectedProjectId)
    );

    const selectedTeam = project.teams.find(
        t => t.name === this.selectedTeamName
    );

    this.liczba_maszyn = selectedTeam.quantity;

    try {
        this.articlesToClone = await this.getArticlesForRequiredModal();
        console.log(
            'ARTYKUŁY DO MODALA:',
            this.articlesToClone
        );

        if (!this.articlesToClone.length) {
            this.errorMsg('Nie udało się pobrać zaznaczonych artykułów.');
            return;
        }
        this.$nextTick(() => {
            this.$refs.addRequiredProjectItemsModalRef.show();
        });

    } catch (error) {
        console.error(
            'Błąd pobierania artykułów ERP:',
            error
        );
        this.errorMsg(
            'Nie udało się pobrać danych artykułów z ERP.'
        );
    }
},
            exportToExcel() {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = '/inventor/parser/export';
                form.target = '_blank';
                const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                const csrfInput = document.createElement('input');
                csrfInput.type = 'hidden';
                csrfInput.name = '_token';
                csrfInput.value = csrf;
                form.appendChild(csrfInput);

                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'data';
                input.value = JSON.stringify(this.sortedEntries);
                form.appendChild(input);

                const nameInput = document.createElement('input');
                nameInput.type = 'hidden';
                nameInput.name = 'nazwa';
                nameInput.value = this.productionout_name;
                form.appendChild(nameInput);

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            },
            showToast(icon, title, message) {
                Toast.fire({
                    position: 'top-end',
                    toast: true,
                    icon,
                    title,
                    html: message,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
        },
    };
</script>

<style scoped>
    .table-responsive {
        max-height: calc(100vh - 200px);
        overflow-y: auto;
    }

    .table thead th {
        position: sticky;
        top: 0;
        background: white;
        z-index: 10;
    }
	.row-added {
    background-color: #f1f9f1 !important;

}

	
	.erp-checkbox {
    width: 22px;
    height: 22px;
    cursor: pointer;
}
</style>